import expertLoginBg from 'assets/svg/ExpertLogin.svg';
import type React from 'react';
import type { ReactNode } from 'react';

interface ExpertBackgroundProps {
  children: ReactNode;
}

const ExpertBackground: React.FC<ExpertBackgroundProps> = ({ children }) => (
  <div className="relative min-h-screen w-full h-full bg-taxes-300">
    <div
      className="fixed z-10 w-full h-full xl:aspect-[620/823] bg-no-repeat bg-cover"
      style={{ backgroundImage: `url(${expertLoginBg})` }}
      aria-hidden="true"
    />
    <div className="relative">{children}</div>
  </div>
);

export default ExpertBackground;
